import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/sections/PageHeader';
import { FaqSection } from '../components/sections/FaqSection';
import { Button } from '../components/ui/button';
import { ArrowLeft, Leaf } from 'lucide-react';
import '../styles/home.css';

const BOOKING_URL = 'https://perfactive.fr/laura-body/new?people=26749';

export default function NaturopathiePage() {
  return (
    <div className="home-container">
      <Helmet>
        <title>Naturopathe Angoulême - Laura Body | Consultation Naturopathie</title>
        <meta name="description" content="Laura Body, naturopathe à Angoulême, vous propose des consultations en naturopathie personnalisées. Spécialisée dans les troubles cutanés (acné, eczéma, psoriasis). Bilan de santé, conseils nutritionnels, phytothérapie. 70€ la consultation." />
        <link rel="canonical" href="https://www.naturopathe-angouleme.fr/naturopathe-angouleme" />
      </Helmet>

      <PageHeader />

      <section className="page-hero-mini">
        <div className="section-container">
          <Link to="/" className="back-link"><ArrowLeft size={16} /> Retour à l'accueil</Link>
          <h1 className="page-hero-title">Naturopathe à Angoulême – Laura Body</h1>
          <p className="page-hero-description">
            Laura Body, naturopathe à Angoulême, vous accompagne avec une approche naturelle et holistique pour optimiser votre santé et votre bien-être au quotidien.
          </p>
        </div>
      </section>

      <section className="services-section">
        <div className="section-container">
          <div className="page-content-block">
            <h2 className="section-title">La naturopathie avec Laura Body à Angoulême</h2>
            <p className="about-text">
              La naturopathie est une approche de santé holistique qui met l'accent sur la prévention et le maintien du bien-être global. Laura Body, naturopathe à Angoulême, s'appuie sur des méthodes naturelles et individualisées afin de vous aider à retrouver et préserver votre équilibre.
            </p>

            <h3 className="benefit-section-title" style={{marginTop: '2rem'}}>Spécialisation : les troubles cutanés</h3>
            <p className="about-text">
              Laura Body, votre naturopathe à Angoulême, s'est spécialisée dans les troubles cutanés. <strong>Acné, eczéma, psoriasis, rosacée…</strong> si vous êtes concerné(e), vous êtes au bon endroit. Ensemble, nous chercherons à comprendre l'origine de ces déséquilibres pour vous aider à retrouver une peau plus saine et un équilibre global.
            </p>

            <h3 className="benefit-section-title" style={{marginTop: '2rem'}}>Ce que comprend une consultation de naturopathie</h3>
            <ul className="benefit-list page-benefit-list">
              <li><Leaf className="benefit-icon" /> Bilan de santé personnalisé</li>
              <li><Leaf className="benefit-icon" /> Analyse de votre hygiène de vie (alimentation, sommeil, stress)</li>
              <li><Leaf className="benefit-icon" /> Conseils nutritionnels adaptés</li>
              <li><Leaf className="benefit-icon" /> Phytothérapie et aromathérapie</li>
              <li><Leaf className="benefit-icon" /> Programme d'accompagnement personnalisé</li>
              <li><Leaf className="benefit-icon" /> Suivi sur la durée</li>
            </ul>

            <h3 className="benefit-section-title" style={{marginTop: '2rem'}}>Pour quels problèmes consulter un naturopathe à Angoulême ?</h3>
            <p className="about-text">
              Vous pouvez consulter Laura Body, naturopathe à Angoulême, pour : le stress, les troubles du sommeil, la fatigue chronique, les problèmes digestifs, les troubles cutanés, la gestion du poids, le renforcement immunitaire, l'accompagnement de pathologies chroniques, ou simplement pour adopter une meilleure hygiène de vie.
            </p>

            <h3 className="benefit-section-title" style={{marginTop: '2rem'}}>Pack Cutané – Naturopathie + Réflexologie</h3>
            <p className="about-text">
              Laura Body propose également un Pack Cutané combinant 4 séances de naturopathie et 4 séances de réflexologie pour un accompagnement complet de vos troubles cutanés. Ce programme à 490€ (au lieu de 540€) permet d'agir en profondeur sur l'origine de vos déséquilibres.
            </p>

            <div className="page-price-block">
              <h3 className="benefit-section-title">Tarif consultation naturopathie</h3>
              <p className="page-price">70€ <span className="page-price-duration">/ 1h30 (première consultation)</span></p>
            </div>
          </div>
        </div>
      </section>

      <FaqSection />

      <section className="page-cta-section">
        <div className="section-container" style={{textAlign: 'center'}}>
          <h2 className="section-title">Consultez Laura Body, naturopathe à Angoulême</h2>
          <p style={{marginBottom: '2rem', color: '#666'}}>Cabinet au 116 rue de Saintes, 16000 Angoulême</p>
          <a href={BOOKING_URL} target="_blank">
            <Button className="btn-primary-hero">Prendre rendez-vous</Button>
          </a>
        </div>
      </section>
    </div>
  );
}
